"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

const DropdownSharedPropsContext = /*#__PURE__*/(0, _react.createContext)({});
var _default = DropdownSharedPropsContext;
exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJEcm9wZG93blNoYXJlZFByb3BzQ29udGV4dCIsImNyZWF0ZUNvbnRleHQiXSwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvY29tcG9uZW50cy9Ecm9wZG93bi9Ecm9wZG93blNoYXJlZFByb3BzQ29udGV4dC9Ecm9wZG93blNoYXJlZFByb3BzQ29udGV4dC50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBjcmVhdGVDb250ZXh0IH0gZnJvbSAncmVhY3QnXG5pbXBvcnQgeyBEcm9wZG93bk9wdGlvbmFsUHJvcHMgfSBmcm9tICcuLi9Ecm9wZG93bi50eXBlcydcblxuY29uc3QgRHJvcGRvd25TaGFyZWRQcm9wc0NvbnRleHQgPSBjcmVhdGVDb250ZXh0PERyb3Bkb3duT3B0aW9uYWxQcm9wcz4oe30pXG5cbmV4cG9ydCBkZWZhdWx0IERyb3Bkb3duU2hhcmVkUHJvcHNDb250ZXh0XG4iXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBQTs7QUFHQSxNQUFNQSwwQkFBMEIsZ0JBQUcsSUFBQUMsb0JBQUEsRUFBcUMsRUFBckMsQ0FBbkM7ZUFFZUQsMEIifQ==